const CommitmentActionTypes = {
  CREATE_COMMITMENT: "CREATE_COMMITMENT",
  FETCH_ALL_COMMITMENTS: "FETCH_ALL_COMMITMENTS",
  FETCH_DEAL_COMMITMENTS: "FETCH_DEAL_COMMITMENTS",
  CHECKOUT_COMMITMENT: "CHECKOUT_COMMITMENT",
};

export default CommitmentActionTypes;
